const DOCUMENT = 'ON_BEHALF_OF_';

const actions = {
  SIGN_IN_REQUEST: DOCUMENT + 'SIGN_IN_REQUEST',
  SIGN_IN_SUCCESS: DOCUMENT + 'SIGN_IN_SUCCESS',
  SIGN_IN_FAIL: DOCUMENT + 'SIGN_IN_FAIL',

  signIn: data => ({
    type: actions.SIGN_IN_REQUEST,
    payload: data,
  }),
  signInSuccess: data => ({
    type: actions.SIGN_IN_SUCCESS,
    payload: data,
  }),
  signInFail: data => ({
    type: actions.SIGN_IN_FAIL,
    payload: data,
  }),
};

export default actions;
